const ModelTypeOfGoods = {

    _id: { id: '_id', typeof: 'string', required: true, default: 'new', fr: 'ID', en: 'ID', description: 'Identifiant unique de l’article', isVisible: false, disabled: false },
    fr: { id: 'fr', typeof: 'string', required: true, default: '', fr: 'Nom en français', en: 'Name in French', description: '', isVisible: true, disabled: false },
    en: { id: 'en', typeof: 'string', required: true, default: '', fr: 'Nom en anglais', en: 'Name in English', description: '', isVisible: true, disabled: false },
    unitPrice: { id: 'unitPrice', typeof: 'numberFloat', required: true, default: 0, fr: 'PU HT', en: 'Unit Price (excl. VAT)', description: 'Prix unitaire hors taxe', isVisible: true, disabled: false },

};

export { ModelTypeOfGoods };